import { Products } from "./products";
import { ProductKey } from "./product-key";

export function isKnownProductKey(product: string): product is ProductKey {
  return product in Products;
}
